import React from 'react';
import ReactDataGrid, { Cell } from 'react-data-grid';
import { Editors } from 'react-data-grid-addons';
import Grid from '@material-ui/core/Grid';
import './Weekly.css';

const { DropDownEditor } = Editors;
const subjectTypes = [
  { id: '1', value: 'Project Management', backgroundColor: '#fdecef' },
  {
    id: '2',
    value: 'Program Life cycle & Initiation',
    backgroundColor: 'c',
  },
  { id: '3', value: 'Project Planning & Scope', backgroundColor: '#ECF9FF' },
  { id: '4', value: 'Project Scheduling', backgroundColor: '#FEF5E9' },
];
let IssueTypeEditor = <DropDownEditor options={subjectTypes} />;

const columns = [
  {
    key: 'time',
    // render: ({ value }) => (
    //   <span style={{ backgroundColor: 'red' }}>{value}</span>
    // ),
  },
  {
    key: 'monday',
    name: 'Monday',
    editorOptions: {
      editOnClick: false,
    },
    editable: function (rowData) {
      console.log('rowData', rowData);
      return rowData.allowEdit === false; // Change to add edit cell option
    },
    editor: IssueTypeEditor,

    formatter: (props) => {
      if (props.value === 'Project Planning & Scope') {
        return <div style={{ background: '#ECF9FF' }}>{props.value}</div>;
      } else if (props.value === 'Project Management') {
        return <div style={{ background: '#fdecef' }}>{props.value}</div>;
      } else if (props.value === 'Program Life cycle & Initiation') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      } else if (props.value === 'Project Scheduling') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      }
      return <div style={{ background: '#FBFCFE' }}>{props.value}</div>;
    },
  },
  {
    key: 'tuesday',
    name: 'Tuesday',
    editor: false,
  },
  {
    key: 'wedesday',
    name: 'Wedesday',
    editor: IssueTypeEditor,
    editable: function (rowData) {
      return rowData.allowEdit === true;
    },
    formatter: (props) => {
      if (props.value === 'Project Planning & Scope') {
        return (
          <div className="timetableDropdown" style={{ background: '#ECF9FF' }}>
            {props.value}
          </div>
        );
      } else if (props.value === 'Project Management') {
        return <div style={{ background: '#fdecef' }}>{props.value}</div>;
      } else if (props.value === 'Program Life cycle & Initiation') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      } else if (props.value === 'Project Scheduling') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      }
      return <div style={{ background: '#FBFCFE' }}>{props.value}</div>;
    },
  },
  {
    key: 'thursday',
    name: 'Thursday',
    editor: IssueTypeEditor,
    editable: function (rowData) {
      return rowData.allowEdit === true;
    },
    formatter: (props) => {
      if (props.value === 'Project Planning & Scope') {
        return (
          <div className="timetableDropdown" style={{ background: '#ECF9FF' }}>
            {props.value}
          </div>
        );
      } else if (props.value === 'Project Management') {
        return <div style={{ background: '#fdecef' }}>{props.value}</div>;
      } else if (props.value === 'Program Life cycle & Initiation') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      } else if (props.value === 'Project Scheduling') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      }
      return <div style={{ background: '#FBFCFE' }}>{props.value}</div>;
    },
  },
  {
    key: 'friday',
    name: 'Friday',
    editor: IssueTypeEditor,
    editable: function (rowData) {
      return rowData.allowEdit === true;
    },
    formatter: (props) => {
      if (props.value === 'Project Planning & Scope') {
        return (
          <div className="timetableDropdown" style={{ background: '#ECF9FF' }}>
            {props.value}
          </div>
        );
      } else if (props.value === 'Project Management') {
        return <div style={{ background: '#fdecef' }}>{props.value}</div>;
      } else if (props.value === 'Program Life cycle & Initiation') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      } else if (props.value === 'Project Scheduling') {
        return <div style={{ background: '#F4F6FF' }}>{props.value}</div>;
      }
      return <div style={{ background: '#FBFCFE' }}>{props.value}</div>;
    },
  },
];

const rows = [
  {
    id: 0,
    time: '9.00 AM',
    monday: 'Project Management',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 1,
    time: '10.00 AM',
    monday: 'Program Life cycle & Initiation',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 2,
    time: '11.00 AM',
    monday: '',
    tuesday: <i><h5 style={{ textAlign: 'center'}}>BREAK</h5></i>,
    wedesday: '',
    thursday: '',
    friday: '',
    allowEdit: false,
  },
  {
    id: 3,
    time: '11.15 AM',
    monday: '--Select Subject--',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 4,
    time: '12.15 PM',
    monday: '--Select Subject--',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 5,
    time: '01.15 PM',
    monday: '',
    tuesday: <i><h5 style={{ textAlign: 'center'}}>LUNCH BREAK</h5></i>,
    wedesday: '',
    thursday: '',
    friday: '',
    allowEdit: false,
  },
  {
    id: 6,
    time: '02.00 PM',
    monday: '--Select Subject--',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 7,
    time: '3.00 PM',
    monday: '',
    tuesday: <i><h5 style={{ textAlign: 'center'}}>BREAK</h5></i>,
    wedesday: '',
    thursday: '',
    friday: '',
    allowEdit: false,
  },
  {
    id: 8,
    time: '3.15 PM',
    monday: '--Select Subject--',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
  {
    id: 9,
    time: '4.15 PM',
    monday: '--Select Subject--',
    tuesday: '',
    wedesday: '--Select Subject--',
    thursday: '--Select Subject--',
    friday: '--Select Subject--',
    allowEdit: true,
  },
];

class WeeklyTime extends React.Component {
  state = { rows };
  checkCellEditable = ({ column, row }) => {
    console.log('columncolumn', column);
  };
  rowKeyGetter({ row }) {
    console.log('rowrowrowrow', row);
    return row.id;
  }
  onCellSelected = ({ rowIdx, idx }) => {
    console.log('rowIDX', rowIdx, idx);
    console.log('idx', rows[idx]);
  };
  onGridRowsUpdated = ({ fromRow, cellKey, toRow, updated }) => {
    this.setState((state) => {
      const rows = state.rows.slice();
      for (let i = fromRow; i <= toRow; i++) {
        rows[i] = { ...rows[i], ...updated };
        console.log('rows[i]', rows[i]);

        // this.changeStyle({ toRow, fromRow, updated });
      }

      return { rows };
    });
  };
  RowRenderer = ({ renderBaseRow, ...props }) => {
    console.log('props------------------->', props);
    const color = props.row.allowEdit === false ? 'nonEditableCell' : '';
    // const startIndex =
    //   props.row.allowEdit === false && props.colVisibleStartIdx === 1;
    // console.log(':startIndex', startIndex);
    return (
      <div className={`react-grid-Cell ${color}`}>{renderBaseRow(props)}</div>
    );
    // const nonEditableRow = props.row.filter((row) => {
    //   return row.allowEdit === false;
    // });
    // console.table('renderBaseRow', nonEditableRow);
  };
  // changeStyle = ({ toRow, fromRow, updated }) => {
  //   var all = document.getElementsByClassName('react-grid-Row');
  //   var cell = document.getElementsByClassName('react-grid-Cell');
  //   for (var i = fromRow; i <= toRow; i++) {
  //     console.log('all', all[i]);
  //     for (var j = all[i]; j <= all[i]; j++) {
  //       console.log('all[i]', j);
  //     }

  //     // console.log('fromRow', fromRow);
  //     // console.log('all', all[i]);
  //   }

  //   // all[i].style.color = 'black';
  //   // all[i].style.background = '#FDECEF';
  // };

  render() {
    return (
      <Grid container item xs={12} spacing={24}>
        <ReactDataGrid
          columns={columns}
          rowKeyGetter={this.rowKeyGetter}
          rowGetter={(i) => this.state.rows[i]}
          rowsCount={9}
          rowRenderer={this.RowRenderer}
          onCellSelected={this.onCellSelected}
          onGridRowsUpdated={this.onGridRowsUpdated}
          enableCellSelect={true}
          onCheckCellEditable={this.checkCellEditable}
        />
      </Grid>
    );
  }
}

export default WeeklyTime;
